export default "__VITE_ASSET__rcAey6Ke__"